import { useState } from 'react';
import { Col, Row, Button as ButtonAntd, Typography, Space } from 'antd';
import { Button } from 'antd-mobile';
import { InfoCircleOutlined } from '@ant-design/icons';
import useTranslations from '../../../../hooks/useTranslations';
import { useBookingCtx } from '../context/BookingContext';
import BookingPreview from './BookingPreview';
import DynamicIcon from '../../../../components/dynamic-icon';
import DrawerBarcode from '../../../../components/global/DrawerBarcode';
import BookingConfirmation from './BookingConfirmation';

const { Text } = Typography;

function BookingBottomBar({ userLatLong }) {
    const { t } = useTranslations();

    const { formInstance } = useBookingCtx();

    const [visibleDrawer, setVisibleDrawer] = useState(false);
    const [showDrawerCustomerSupport, setVisibleCustomerSupport] = useState(false);

    const textProceedToBook = t('ProceedToBook', 'Proceed to Book');
    const textCustomerSupport = t('CustomerSupport', 'Customer Support');
    const textNeedHelpWithYourBookingOrServices = t('NeedHelpWithYourBookingOrService', 'Need help with your booking services');

    const onClose = () => {
        setVisibleDrawer(false);
    };

    return (
        <>
            <div
                style={{
                    background: '#ccf3ee',
                    height: 143,
                    display: 'flex',
                    alignItems: 'center',
                    padding: 16,
                    maxWidth: 430,
                    width: '100%',
                }}
            >
                <Row style={{ width: '100%', rowGap: 20 }}>
                    <BookingPreview userLatLong={userLatLong} refetchKey={visibleDrawer} />
                    <Row wrap={false} align="middle" style={{ width: '100%', gap: 12 }}>
                        <Col flex="none">
                            <ButtonAntd
                                onClick={() => setVisibleCustomerSupport(true)}
                                style={{ borderRadius: 8, height: 40, width: 40 }}
                                icon={<DynamicIcon iconName="headset" />}
                            />
                        </Col>
                        <Col flex="auto">
                            <Button
                                onClick={() =>
                                    formInstance
                                        .validateFields()
                                        .then(() => {
                                            setVisibleDrawer(true);
                                        })
                                        .catch((info) => {
                                            formInstance.scrollToField(info.errorFields[0].name);
                                        })
                                }
                                color="primary"
                                style={{
                                    width: '100%',
                                    display: 'flex',
                                    justifyContent: 'center',
                                }}
                            >
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        color: 'white',
                                        gap: 9,
                                    }}
                                >
                                    <Text style={{ color: 'white' }}>{textProceedToBook}</Text>
                                    <DynamicIcon iconName="verify" />
                                </div>
                            </Button>
                        </Col>
                    </Row>
                </Row>
            </div>
            {showDrawerCustomerSupport && (
                <DrawerBarcode title={textCustomerSupport} visible={showDrawerCustomerSupport} onClose={() => setVisibleCustomerSupport(false)}>
                    <div style={{ background: '#DFF8F5', padding: 8 }}>
                        <Row style={{ gap: 16 }} wrap={false} align="top">
                            <InfoCircleOutlined style={{ color: 'var(--primary-color)', padding: '8px 0' }} />
                            <Space direction="vertical" style={{ width: '100%' }}>
                                <Text strong style={{ fontSize: 16 }}>
                                    {textNeedHelpWithYourBookingOrServices}
                                </Text>
                                <Text>
                                    Our customer support is ready to assist you via <Text strong>LINE, WhatsApp, WeChat, or Telegram</Text>. Simply
                                    click one of the available contact options to start chatting with us.
                                </Text>
                            </Space>
                        </Row>
                    </div>
                </DrawerBarcode>
            )}
            {visibleDrawer && <BookingConfirmation formInstance={formInstance} visible={visibleDrawer} onClose={onClose} />}
        </>
    );
}

export default BookingBottomBar;
